import { defineMessages } from 'react-intl';

export const SliderMessages = defineMessages({
  Month: {
    id: 'ic-slider-month',
    defaultMessage: '{installment, plural, one {Monat} other {Monate}}',
  },
});
